import {
  ScrollArea,
  hideScrollBarsFromScreenReadersContext,
  eventCalculate,
} from '@semcore/base-components';
import type { ScrollAreaProps } from '@semcore/base-components';

export {
  /**
   * @deprecated Use ScrollArea from `@semcore/base-components` instead. Package `@semcore/scroll-area` will be removed in the next major release
   */
  ScrollArea,
  /**
   * @deprecated Use hideScrollBarsFromScreenReadersContext from `@semcore/base-components` instead. Package `@semcore/scroll-area` will be removed in the next major release
   */
  hideScrollBarsFromScreenReadersContext,
  /**
   * @deprecated Use eventCalculate from `@semcore/base-components` instead. Package `@semcore/scroll-area` will be removed in the next major release
   */
  eventCalculate,
};

export type {
  /**
   * @deprecated Use ScrollAreaProps from `@semcore/base-components` instead. Package `@semcore/scroll-area` will be removed in the next major release
   */
  ScrollAreaProps,
};

/**
 * @deprecated Use ScrollArea from `@semcore/base-components` instead. Package `@semcore/scroll-area` will be removed in the next major release
 */
export default ScrollArea;
